import { FieldRule } from './types';

export function evalRules<TCtx>(
  rules: FieldRule<TCtx>[] | undefined,
  bag: { values: Record<string, any>; ctx: TCtx }
) {
  const acc = {
    hidden: false,
    disabled: false,
    required: false,
    readOnly: false,
  };
  if (!rules) return acc;
  for (const r of rules) {
    const ok =
      typeof r.when === 'function' ? r.when(bag) : safeEval(r.when, bag);
    if (ok && r.set) Object.assign(acc, r.set);
  }
  return acc;
}

function safeEval(expr: string, bag: any) {
  try {
    const fn = new Function('values', 'ctx', `return (${expr});`);
    return fn(bag.values, bag.ctx);
  } catch {
    return false;
  }
}
